// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1CSDT","inner":"Footer_inner__1VSw-","nextIcon":"Footer_nextIcon__ubkLB","innerLeft":"Footer_innerLeft__1GOAE"};